<template>
  <div class="base-table-bd tb" v-if="funcView.table_field_list">
    <div class="search-hd">
      <el-form :inline="true" @submit.native.prevent>
        <el-form-item>
          <el-button type="primary" icon="el-icon-plus" @click="addMenuColumn()" v-if="funcView.table_field_add">{{ funcView.table_field_add }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="icon icon-piliangtianjia" v-if="funcView.table_field_copy" :disabled="!tableSelect.length" @click="addBatchMenuColumn()">
            &ensp;{{ funcView.table_field_copy }}
          </el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="icon icon-refresh" @click="updateLangKey()" :disabled="!tableSelect.length">{{ $t('base_tables.ensptbdyyKey') }}</el-button>
        </el-form-item>
        <!-- 配置项 -->
        <el-form-item style="float: right; margin-right: 0">
          <custom-column ref="column"></custom-column>
        </el-form-item>
        <!-- 搜索栏 -->
        <el-form-item style="float: right">
          <search-input :placeholder="$t('base_tables.bgdmzdmczddm')" v-model="formSearch.search" @fetch="onPageChange({ page: 1 })"></search-input>
        </el-form-item>
        <el-form-item style="float: right">
          <custom-select
            v-model="formSearch.menuId"
            type="tree"
            url="MenuTree"
            :auto="false"
            :listener="formSearch.appId"
            :params="{ appId: formSearch.appId }"
            :show-all-levels="false"
            :cascaderKey="formSearch.appId"
            :props="{ label: 'menuName', value: 'menuId', checkStrictly: true, emitPath: false }"
            :placeholder="$t('base_tables.suo_shu_cai_dan')"
            width="200px"
            @change="getTableList"
          ></custom-select>
        </el-form-item>
        <!-- 应用下拉 -->
        <el-form-item style="float: right">
          <custom-select
            v-model="formSearch.appId"
            url="AppMenu"
            :props="{ label: 'appName', value: 'appId' }"
            :placeholder="$t('base_tables.suo_shu_ying_yong')"
            width="200px"
            :dataFilter="dataFilter"
            @change="changeApp"
          ></custom-select>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-bd">
      <custom-table type="checkbox" tableCode="table_field" v-model="tableSelect" :data="menuColumnList" @column="setColumn" @filter="filterChange" @sort="sortChange" height="100%">
        <el-table-column :label="$t('Common.com_handle')" min-width="160" fixed="right">
          <template slot-scope="scope">
            <el-button @click="editMenuColumn(scope.row)" type="text" size="mini" v-if="funcView.table_field_edit">{{ funcView.table_field_edit }}</el-button>
            <el-button @click="deleteMenuColumn(scope.row)" type="text" size="mini" v-if="funcView.table_field_delete">{{ funcView.table_field_delete }}</el-button>
          </template>
        </el-table-column>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>
    <table-column-dialog v-if="dialogVisible" :data="dialogData" :model="dialogModel" @close="dialogVisible = false" @success="getTableList"></table-column-dialog>
    <table-columns-dialog v-if="dialogVisible1" :data="dialogData1" :model="dialogModel1" @close="dialogVisible1 = false" @success="getTableList"></table-columns-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import tableColumnDialog from './children/table_column_dialog.vue';
import tableColumnsDialog from './children/table_columns_dialog.vue';

export default {
  name: 'tables',
  components: { tableColumnDialog, tableColumnsDialog },
  data() {
    return {
      appList: [],
      appTree: [],
      menuData: {},
      tableSelect: [],

      dialogVisible: false,
      dialogModel: {},
      dialogData: {},
      dialogVisible1: false,
      dialogModel1: {},
      dialogData1: {},

      formSearch: {
        appId: '',
        menuId: '',
        search: '',
        orderType: '',
        orderBy: '',
        pageSize: 50,
        pageNum: 1,
      },
      menuColumnList: [],
      totalRows: null,
      isLoading: false,

      treeProps: {
        children: 'children',
        label: 'menuName',
      },
    };
  },
  mounted() {
    this.getFuncView();

    this.getTableList();
  },
  methods: {
    changeApp: function () {
      this.formSearch.menuId = '';
      this.getTableList();
    },
    // 应用平台(过滤)
    dataFilter: function (list) {
      return list.filter((t) => t.appCode !== 'isynergy_cloud');
    },
    // 获取字典项列表
    getTableList: function () {
      this.$getJSON(apis.TableColumnPage, this.formSearch).then((res) => {
        this.menuColumnList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 新增表格列
    addMenuColumn: function () {
      this.dialogModel.type = 'add';
      this.dialogModel.title = this.$t('base_tables.xzbgzd');
      this.dialogModel.data = {
        appId: this.formSearch.appId,
        menuId: this.formSearch.menuId,
      };
      this.dialogVisible = true;
    },
    addBatchMenuColumn: function () {
      this.dialogModel1.type = 'add';
      this.dialogModel1.title = this.$t('Common.com_copy');
      this.dialogModel1.data = this.tableSelect;
      this.dialogVisible1 = true;
    },
    // 编辑表格列
    editMenuColumn: function (data) {
      this.dialogModel.type = 'edit';
      this.dialogModel.title = this.$t('base_tables.bjbgzd');
      this.dialogModel.data = {};
      this.dialogModel.data.item = data;
      this.dialogVisible = true;
    },
    sleep: async function (time) {
      return new Promise((resolve) => {
        setInterval(() => {
          resolve();
        }, time);
      });
    },
    updateLangKey: async function () {
      /* eslint-disable */
      console.info(this.$t('base_tables.dyyKeytbks'));
      for (let i = 0; i <= this.tableSelect.length - 1; i++) {
        await this.sleep(300);
        /* eslint-disable */
        const tableRow = this.tableSelect[i];
        await this.$postJSON(apis.TableColumnUpdate, tableRow);
        /* eslint-disable */
        console.info(this.$t('base_tables.ogeng_xin_wan_cheng', [tableRow.langColumnName]));
      }
      this.$message({
        message: this.$t('base_tables.tong_bu_wan_cheng'),
        type: 'success',
      });
      /* eslint-disable */
      console.info(this.$t('base_tables.dyyKeytbjs'));
    },
    // 删除表格列
    deleteMenuColumn: function (data) {
      const tips = this.$t('base_tables.nqdyscxzdbgzdm');
      this.$showConfirm(tips)
        .then(() => {
          this.$postJSON(`${apis.TableColumnDelete}/${data.columnId}`).then(() => {
            this.$message({
              message: this.$t('Common.com_delete_success'),
              type: 'success',
            });
            this.getTableList();
          });
        })
        .catch(() => {});
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
  },
};
</script>

<style lang="scss">
@import '@/style/mixin.scss';

.base-table-bd {
  .aside {
    .el-input--mini .el-input__inner {
      @include color_main();
    }
  }
}
</style>
